
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);

function shipping_progress_bar(){
    let shopify_country = Shopify.country;
    let store_symbol = document.body.getAttribute('data-money-format') || "${{amount}}";
    let before_symbol = store_symbol.split('{')[0] || '';
    let after_symbol = (store_symbol.split('}}')[1] || '').trim();
    let dataInput = document.getElementById('datajsonvalue');
    if(!dataInput){
        console.error("Missing #datajsonvalue input with JSON URL");
        return;
    }
    let dataUrl = dataInput.value;

    fetch(dataUrl)
    .then(response => response.json())
    .then(data => {
        if(data[shopify_country]){
            setTimeout(() => {
                let shipping_rate = parseFloat(data[shopify_country].free_shipping_order_value);
                let country_symbol = data[shopify_country].money_symbol;
                let cartElement = document.querySelector('.cart__grandtotal');
 
                let val = cartElement.getAttribute('data-total');
                let cart_total = cartElement ? parseFloat(cartElement.getAttribute('data-total')) : 0;
                let barEls = document.querySelectorAll('#myBar, .custom-minicart #myBar, .section--cart-page #myBar');
                let msgEls = document.querySelectorAll('.shipping-msg');
                msgEls.forEach(msgEl => {
                  if (shipping_rate > val) {
                    let ship_amt = (shipping_rate - cart_total).toFixed(2);
                    let shipping_percent = ((cart_total / shipping_rate) * 100).toFixed(2);

                    msgEl.innerHTML = `Shop for <b>${country_symbol} ${ship_amt} </b> more for <b>FREE SHIPPING !</b>`;
                    document.querySelectorAll(".myProgress-wrap #myBar").forEach(el => {
                      el.style.width = shipping_percent + "%";
                    });
                  } else {
                    msgEl.innerHTML = `<b>FREE SHIPPING !</b>`;
                    barEls.forEach(el => el.style.width = '100%');
                  }
                });
            }, 1500);
        }
    })
    .catch(err => {
        console.error("Error loading JSON", err);
    });
}

document.addEventListener("DOMContentLoaded", function() {
  document.addEventListener('booster:cart:update', function(e) {
    shipping_progress_bar();
  });
});

